module.exports = __webpack_public_path__ + "static/media/ZWZ General bearing catalogue_compressed.3f8678af.pdf";